export { default } from './horizontal-info';
